import { AvatarGroup as MuiAvatarGroup } from '@mui/material';
import React, { FC } from 'react';

import { AVATARS_MAX_LENGTH } from '../../../constants/preferences';
import { User } from '../../../generated/graphql';

import MuiAvatar from '../Avatar';
import { AvatarSize } from '../Avatar/types';

import { getSurplusStyles } from './styled';

type Props = {
  size: AvatarSize;
  users: Array<
    Pick<User, 'firstName' | 'id' | 'imageUrl' | 'lastName' | 'status'>
  >;
};

/**
 * Avatar component
 *
 * @param props       Props passed to the component
 * @param props.size  The size of the avatar
 * @param props.users The user to generate the avatar groups for
 * @returns           The component itself
 */
const AvatarGroup: FC<Props> = ({ users, size = 'medium' }) => {
  return (
    <MuiAvatarGroup
      max={AVATARS_MAX_LENGTH}
      slotProps={{
        surplus: { sx: getSurplusStyles(size) },
      }}
    >
      {users.map(user => (
        <MuiAvatar key={user.id} size={size} user={user} />
      ))}
    </MuiAvatarGroup>
  );
};

export default AvatarGroup;
